<template>
  <li class="dropdown nav-item"
      :is="tag"
      :class="{show: isOpen}"
      aria-haspopup="true"
      :aria-expanded="isOpen"
      @click="toggleDropDown"
      v-click-outside="closeDropDown">

    <a class="nav-link dropdown-toggle"
       data-toggle="dropdown">
      <slot name="title">
        <i :class="icon"></i>
        <span class="no-icon">{{title}}</span>
        <b class="caret"></b>
      </slot>
    </a>
    <div class="dropdown-menu" ref="dropdownMenuContent">
      <slot></slot>
    </div>
  </li>
</template>
<script>
  export default {
    name: 'base-dropdown',
    props: {
      title: String,
      icon: String,
      tag: {
        type: String,
        default: 'li'
      }
    },
    data () {
      return {
        isOpen: false
      }
    },
    methods: {
      toggleDropDown () {
        this.isOpen = !this.isOpen
        this.$emit('change', this.isOpen)
        this.showHideDropdown();
      },
      closeDropDown () {
        this.isOpen = false
        this.$emit('change', this.isOpen);
        let thisDropdown = this.$refs.dropdownMenuContent;
        thisDropdown.classList.remove('fadeIn');
      },
      showHideDropdown () {
        let thisDropdown = this.$refs.dropdownMenuContent;
        if (this.isOpen) {
          thisDropdown.classList.add('fadeIn');
        } else {
          thisDropdown.classList.remove('fadeIn');
        }
      }
    }
  }
</script>
<style scoped>
  .dropdown .dropdown-toggle{
    cursor: pointer;
  }
  

  .fadeIn {
    display: block;
    animation: fadeIn 0.3s ease-in-out;
  }

  @keyframes fadeIn {
    0% {
      scale: 0.5;
    }
    80% {
      scale: 1.1;
    }
    100% {
      scale: 1;
    }
  }

</style>
